const gtag = () => window.gtag ? window.gtag : console.log;

export interface EventDetails {
  event_category: string;
  event_label: string;
  platform?: string;
  name?: string;
  method?: string;
}

export const logEvent = (action: string, details: EventDetails) => {
  gtag()('event', action, {
    ...details,
  });
};

export const logPageView = (title: string) => {
  gtag()('event', 'page_view', {
    page_title: title,
    page_location: window.location.href,
  });
};
